module.exports = __webpack_public_path__ + "media/images/icons/country_flags/bj-b04c72b67773f10058a853b2a3991192.svg";